/**
 * 统一钱包会话状态与授权请求
 */

export function isWalletSessionComplete() {
  const token = localStorage.getItem('wallet_token')
  const userInfo = localStorage.getItem('user_info')
  let walletInfo = null
  try {
    walletInfo = JSON.parse(localStorage.getItem('wallet_info') || 'null')
  } catch {
    walletInfo = null
  }
  const address = walletInfo?.address || localStorage.getItem('address')
  return !!(token && userInfo && address)
}

const authHandlers = new Set()

export function registerWalletAuthHandler(handler) {
  if (typeof handler !== 'function') return () => {}
  authHandlers.add(handler)
  return () => authHandlers.delete(handler)
}

export function requestWalletAuthorization() {
  if (authHandlers.size > 0) {
    authHandlers.forEach((handler) => {
      try {
        handler()
      } catch (error) {
        console.error('wallet auth handler failed:', error)
      }
    })
    return
  }
  window.dispatchEvent(new CustomEvent('start-wallet-authorization'))
}

export function safeRouterPush(router, location) {
  if (!router) return Promise.resolve()
  return router.push(location).catch((error) => {
    if (error?.name !== 'NavigationDuplicated' && !String(error?.message || '').includes('Avoided redundant navigation')) {
      console.warn('router push failed:', error)
    }
  })
}

export function navigateBack(router, fallback = '/assets') {
  if (!router) return Promise.resolve()
  const canGoBack = Boolean(window.history.state?.back)
  if (canGoBack) {
    return router.back().catch(() => safeRouterPush(router, fallback))
  }
  return safeRouterPush(router, fallback)
}

export function isInteractiveTouchTarget(target) {
  if (!target || typeof target.closest !== 'function') return false
  return !!target.closest(
    'button, a, input, textarea, select, label, summary, [role="button"], [role="link"], .nav-item, .menu-row, .book-row, .hero-actions button, .router-link-active, .router-link'
  )
}
